export async function postSendEmail(fromAddress, subject, emailBody) {
	const response = await fetch('https://first-function-test-wvvm2ouliq-uk.a.run.app', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			fromAddress: fromAddress,
			subject: subject,
			emailBody: emailBody
		}),
	});

	const result = await response;
	console.log(result);
}

export async function getBulletinPdfBase64(parish) {
	try {
		const response = await fetch(`https://bulletin-scraper-96545409792.us-east4.run.app/${parish}`);
		if (!response.ok) { throw new Error(`Server error: ${response.status}`); }
		const data = await response.json();
		return data;
	} catch (err) {
		console.error('GET request failed:', err);
		return null;
	}
}
